import { isUnderTest } from "../utils";
const doWindow = window;
export function buildAdditionalData(form) {
    let comment = form.commentAddition.value;
    let altDealerId = undefined;
    const subtitle = form
        .closest(".sdp_wrapper")
        ?.querySelector(".sdp_subtitle")?.textContent;
    const offerValue = form
        .closest(".sdp_wrapper")
        ?.querySelector(".sdp_value strong")?.textContent;
    if (subtitle) {
        comment += ", Subtitle: " + subtitle;
    }
    if (offerValue) {
        comment += ", Value: " + offerValue;
    }
    comment += ", URL: " + window.location.href;
    const optOut = form.querySelector("#optOut");
    if (optOut) {
        comment += ", Do Not Sell Personal Info: " + optOut.checked;
    }
    const childDealerField = form.ChildDealerId;
    if (childDealerField) {
        const childDealerId = childDealerField.value;
        const childDealerName = childDealerField.options[childDealerField.selectedIndex].textContent;
        comment += `, ChildDealerName: ${childDealerName}, ChildDealerId: ${childDealerId}`;
    }
    else if (form.AltDealerId) {
        altDealerId = form.AltDealerId.value;
    }
    const make = document.getElementById("txtMake")?.value;
    if (typeof make === "string") {
        const model = document.getElementById("txtModel")
            ?.value;
        const year = document.getElementById("txtYear")
            ?.value;
        const trim = document.getElementById("txtTrim")
            ?.value;
        return {
            VehicleMake: make,
            VehicleModel: model,
            VehicleYear: year,
            VehicleTrim: trim,
            Comments: comment,
            AltDealerId: altDealerId,
        };
    }
    return {
        AltDealerId: altDealerId,
        Comments: comment,
    };
}
export default class SpecialDetailsForm {
    constructor() {
        this.submissionMethod = {
            leadSource: (form) => parseInt(form.leadSource.value),
            additionalData: (form) => buildAdditionalData(form),
        };
        this.setLeadSource = () => (this._form.leadSource.value = doWindow.DoUtility.isMobile
            ? this._form.mobileLeadSource.value
            : this._form.desktopLeadSource.value);
        this._form = document.getElementById("spForm");
        this.initialize();
    }
    initialize() {
        doWindow.DealeronLead.addSubmissionMethod("specialsSubmitMethod", this.submissionMethod);
        doWindow.DealeronLead.initialize("#spForm", "specialsSubmitMethod");
        this.addEventListeners();
        this.setLeadSource();
    }
    addEventListeners() {
        this._form.FirstName.addEventListener("focusout", doWindow.DealeronLead.begin);
        if (this._form.CompanyName) {
            this._form.CompanyName.addEventListener("change", () => this.showCnpjGroup());
        }
    }
    showCnpjGroup() {
        const cpfFormGroup = document.querySelector("[id^='piFormGroup']");
        const cpfInputElem = document.querySelector("[id^='pi']");
        const cnpjFormGroup = document.querySelector("[id^='cnpjFormGroup']");
        const cnpjInputElem = document.querySelector("[id^='cnpj']");
        if (this._form.CompanyName.value) {
            // Show CNPJ form group, hide CPF form group
            cpfFormGroup.hidden = true;
            cnpjFormGroup.hidden = false;
            // prevent hidden input value from being submitted in lead
            cpfInputElem.setAttribute("data-dlron-lead-ignored", "");
            cnpjInputElem.removeAttribute("data-dlron-lead-ignored");
        }
        else {
            // Hide CNPJ form group and show CPF form group when companyName is empty
            cnpjFormGroup.hidden = true;
            cpfFormGroup.hidden = false;
            cnpjInputElem.setAttribute("data-dlron-lead-ignored", "");
            cpfInputElem.removeAttribute("data-dlron-lead-ignored");
        }
    }
}
if (!isUnderTest()) {
    doWindow.DoUtility.SelfInstantiateOnLoad(SpecialDetailsForm);
}
